export default __webpack_public_path__ + "static/img_spindlebooks_ipad-7172d1fedcc0ff7857fcf1f05fbe45ee.png";